export const getURLObject = (url: string): URL | null => {
  try {
    return new URL(url)
  } catch {
    return null
  }
}
